<template>
  <gmap-map
    id="googleMap"
    :center="getCenter"
    :zoom="zoomMap"
    style="width:100%;"
    ref="gmap"
  >
    <gmap-circle
      :center="getCenter"
      :radius="getRadius"
      :options="{
        fillColor: '#009640', 
        fillOpacity: 0.1, 
        strokeColor: '#009640',
        strokeOpacity: 0.1
      }"
    ></gmap-circle>

    <MarkerUser :locationUser="getLocationUser" :infoOptions="infoOptions"/>

    <MarkerPoints 
      :infoOptions="infoOptions"
      v-on:onGenerateRoute="generateRoute"/>
    
  </gmap-map>
</template>

<script>
//import DirectionsRenderer from '../service/DirectionsRenderer.js';
import MarkerUser from './makers/MarkerUser';
import MarkerPoints from './makers/MarkerPoints';
import { mapGetters, mapActions } from 'vuex';

/* El comentario de abajo no se debe borrar, porque con él se puede utilizar el componente google de forma global */
/* global google */
export default {
  name: "GoogleMap",
  /* Componente que contiene el mapa de Google Maps */
  components: {
    //DirectionsRenderer, 
    MarkerUser,
    MarkerPoints
  },
  directionsService: null,
  directionsDisplay: null,
  data() {
    return {
      markerSelect : { lat: 0, lng: 0 },
      infoWindowPos: { lat: 0, lng: 0 },
      markers: [/* { position: { lat: 2.44412034, lng: -76.61924957 } } */],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      travelMode: null,
      directions: null,
      dialog: false,
      textAlert: '',
      directionsObj: {}
    };
  },
  computed: {
    ...mapGetters(['getCenter', 'getRadius', 'getLocationUser', 'getMarketSelect', 'getTravelMode']),
    zoomMap(){
      if(this.getLocationUser.lat != 0){
        switch(this.getRadius){
          case 500: return 16
          case 1000: return 15.2
          case 1500: return 14.7
          default: return 6;
        }
      } else {
        return 6;
      }
      
    },
  },
  mounted() {
    this.$nextTick(function() {
      this.$gmapApiPromiseLazy().then(() => {
        this.$options.directionsService = new google.maps.DirectionsService()
        this.$options.directionsDisplay = new google.maps.DirectionsRenderer()
        this.$options.directionsDisplay.setMap(this.$refs.gmap.$mapObject)
      })
    })
  },
  methods: {
    ...mapActions(['addDialog', 'closeCards', 'addDirections', 'addTravelMode']),
    generateRoute(modeTra, select){
      this.travelMode = modeTra;
      if(select != null){
        this.markerSelect = select;
      }
      this.getDirection()
    },
    getDirection() {
      this.$gmapApiPromiseLazy().then(() => {
        this.$options.directionsDisplay.set('directions', null)
        this.$options.directionsService.route(
          {
            origin: this.getLocationUser,
            destination: this.getMarketSelect,
            travelMode: this.getTravelMode
          },
          (result, status) => {
            if (status === 'OK') {
              this.$options.directionsDisplay.setOptions({
                suppressMarkers: true,
                polylineOptions: {
                  strokeColor: '#0071bc'
                }
              })
              this.$options.directionsDisplay.setDirections(result)
              this.directionsObj.distance = result.routes[0].legs[0].distance.text;
              this.directionsObj.duration = result.routes[0].legs[0].duration.text;
              this.directionsObj.steps = result.routes[0].legs[0].steps;
              this.directionsObj.end_address = result.routes[0].legs[0].end_address;
              this.directionsObj.start_address = result.routes[0].legs[0].start_address;
              this.directionsObj.travelMode = this.travelMode;
              this.addDirections(null);
              this.addDirections(this.directionsObj);

            } else {
              this.closeCards()
              this.addDialog("Lo sentimos, no tenemos resultados para esta acción.");
              this.addTravelMode('DRIVING');
            }
          }
        )
      })
    }
  }
};
</script>

<style scoped>
.v-btn:not(.v-btn--round).v-size--large {
  padding: 3px 9px !important;
}
</style>